(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kavith-about-us"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.kaInit) return;
      root.dataset.kaInit = '1';
      var items = root.querySelectorAll('[data-ka-reveal]');
      if (!items.length || !('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('ka-js');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    }
    function all() { document.querySelectorAll('.ka').forEach(init); }
    if (document.readyState !== 'loading') all();
    else document.addEventListener('DOMContentLoaded', all);
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target && e.target.querySelector('.ka');
      if (r) init(r);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
